export default __webpack_public_path__ + "static/media/cashWhite.da059c4e.svg";